'use client';

import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { useContext, useMemo } from 'react';

import { InfoContext } from '@/context/info';

import { DyItems } from './dy-items';
import { InhouseItems } from './inhouse-items';
import type { Component } from './types';

export const RecommendedForYouForInfo: Component = () => {
  const { dyArticles } = useContext(InfoContext);
  const { isIpadMini } = useScreenDetect();
  const isIpadMiniMode = isIpadMini();

  const component = useMemo(() => {
    if (dyArticles.length !== 0 && !isIpadMiniMode) {
      return (
        <DyItems />
      );
    }

    return (
      <InhouseItems />
    );
  }, [dyArticles.length, isIpadMiniMode]);

  return component;
};
